export default (app) => {
  const loading = document.getElementById("nystem-loading");
  if (!loading) return;

  document.getElementById("nystem-loading-name").textContent = app.settings.name || "";
  const description = document.getElementById("nystem-loading-description");
  description.textContent = app.settings.description || "";
  description.hidden = !app.settings.description || app.settings.description === app.settings.name;

  let updating = false;
  app.on("pageLoading", ({ visible = true, update = false, error = false }) => {
    if (update) updating = true;
    if (error) updating = false;
    if (!visible && updating) return;

    loading.hidden = !visible;
    loading.setAttribute("aria-busy", String(visible && !error));
    document.getElementById("nystem-loading-spinner").hidden = error;
    document.getElementById("nystem-loading-status").textContent = error
      ? "Unable to load. Reload the page to try again."
      : app.t(update ? "Updating…" : "Loading…");
  });
};
